import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, CircularProgress, Alert, Stack } from '@mui/material';
import { httpClient, adminBase } from './dataProvider';
import SortableTable from './components/SortableTable';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import QuizIcon from '@mui/icons-material/Quiz';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const AdminDashboard = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const url = `${adminBase}/dashboard_stats/`;
        httpClient(url)
            .then(({ json }) => {
                setRows(Array.isArray(json) ? json : []);
                setLoading(false);
            })
            .catch((e) => {
                console.error('Failed to fetch admin dashboard stats:', e);
                setError('Failed to load dashboard stats');
                setLoading(false);
            });
    }, []);

    return (
        <Card sx={{ m: 2 }}>
            <CardContent>
                <Typography variant="h5" component="h2" gutterBottom>
                    Admin Dashboard
                </Typography>
                {loading ? (
                    <CircularProgress />
                ) : error ? (
                    <Alert severity="error">{error}</Alert>
                ) : (
                    <SortableTable
                        data={rows.map(r => ({ id: r.course_id, ...r }))}
                        rowKey="id"
                        columns={[
                            { key: 'course_name', header: 'Course Name' },
                            { key: 'complexity', header: 'Complexity' },
                            { key: 'textbooks', header: (<Stack direction="row" spacing={0.5} alignItems="center"><MenuBookIcon fontSize="small"/> <span>Textbooks</span></Stack>), align: 'right' },
                            { key: 'podcasts', header: (<Stack direction="row" spacing={0.5} alignItems="center"><HeadphonesIcon fontSize="small"/> <span>Podcasts</span></Stack>), align: 'right' },
                            { key: 'videos', header: (<Stack direction="row" spacing={0.5} alignItems="center"><OndemandVideoIcon fontSize="small"/> <span>Videos</span></Stack>), align: 'right' },
                            { key: 'exams', header: (<Stack direction="row" spacing={0.5} alignItems="center"><QuizIcon fontSize="small"/> <span>Exams</span></Stack>), align: 'right' },
                            { key: 'questions', header: (<Stack direction="row" spacing={0.5} alignItems="center"><HelpOutlineIcon fontSize="small"/> <span>Questions</span></Stack>), align: 'right' },
                        ]}
                        tableProps={{ size: 'small' }}
                        defaultSort={{ key: 'course_name', direction: 'ascending' }}
                    />
                )}
            </CardContent>
        </Card>
    );
};

export default AdminDashboard;
